import React from "react";
import { Link } from "@reach/router";


const AboutArea = () => {
  return (
    <section id="about" className="about-area">
      <div className="container">
        <div
          className="row justify-content-center"
          data-anime="opacity:[0, 1]; translateY:[24, 0]; onview: true; delay: 100;"
        >
          <div className="col-xl-8 col-lg-10">
            <div className="section__title text-center title-mb-80">
              {/* <h2 className="title">About the platform</h2> */}
            </div>
          </div>
        </div>
        <div className="about__row-reverse">
         
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div
                className="about__img"
                data-anime="opacity:[0, 1]; translateX:[24, 0]; onview: -250; delay: 300;"
              >
                <img src="/assets/img/others/features-02.png" alt="img" />
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="about__content"
                data-anime="opacity:[0, 1]; translateX:[-24, 0]; onview: -250; delay: 400;"
              >
                <div className="section__title text-start">
                  <span className="sub-title tg-text-gradient">
                  TOKENIZED PLATFORM
                  </span>
                  <h2 className="title">Fusion of Crypto and AI</h2>
                </div>
                <p>
                A leading platform tokenized on Binance Smart Chain. 
                Our app offers automatic trading, rewards on payments, 
                DeFi solutions.
                <br />
                Partnering with major projects, we bring you unparalleled collaboration
                and innovation in the crypto space. 
                Explore the future of finance with Panther AI App!
                </p>
                <div className="about__facts-list">
                  <div className="about__icon-box">
                    <div className="icon">
                      <i className="unicon-select-02"></i>
                    </div>
                    <p>Staking (SOON)</p>
                  </div>
                  <div className="about__icon-box">
                    <div className="icon">
                      <i className="unicon-select-window"></i>
                    </div>
                    <p>Investing (SOON)</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row align-items-center section-pt-80">
            <div className="col-lg-6">
              <div
                className="about__img"
                data-anime="opacity:[0, 1]; translateX:[-24, 0]; onview: -250; delay: 200;"
              >
                <img src="/assets/img/others/features-03.png" alt="img" />
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="about__content"
                data-anime="opacity:[0, 1]; translateX:[24, 0]; onview: -250; delay: 300;"
              >
                <div className="section__title text-start">
                  <span className="sub-title tg-text-gradient">
                    Intelligent Eco
                  </span>
                  <h2 className="title">
                    Potential of DeFi
                  </h2>
                </div>
                <p>
                Experience the power of community ownership, global governance, and explore infinite use cases within the PantherAI ecosystem.
                </p>
                <div className="about__facts-list">
                  <div className="about__fact-item">
                    <a
                      href="https://doc.pantherai.app/white-paper/pai-whitepaper"
                      data-target="#collection"
                      target="blank"
                      className="banner__btn btn gradient-btn gradient-btn-2 scroll-to-target"
                    >
                      <span>Download White Paper</span>
                      <i className="unicon-arrow-up-right"></i>
                    </a> 
                  </div>
                  
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </section>
  )
}

export default AboutArea
